import { getRequest, postRequest } from "./genericsRequest"

export const initialMessageApi = () => getRequest('/message/welcome').then(data => data)

export const searchBotAPI = (message) => getRequest(`/searchBot/${encodeURI(message)}`)

export const botNameApi = () => getRequest('/name').then(data => data.name)

export const noRelevanceApi = () => getRequest('/message/norelevance').then(data => data.message)

export const helpMessageApi = () => getRequest('/message/help').then(data => data.message)

export const invalidMessage = () => getRequest('/message/type').then(data => data.message)

export const sendFeedback = async (queryId, resultId, isRelevant) => {
  const endpoint = '/feedback'
  const response = await postRequest(endpoint, { queryId, resultId, isRelevant })
  return response
}